export default {
	state: {
		invoices: [],
		invoiceStatuses: []
	},

	actions: {
		getInvoices(actionContext, status) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetInvoices?userid=${profile.userid}&status=${status}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setInvoices", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getInvoice(actionContext, id) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetInvoice?userid=${profile.userid}&id=${id}`)
						.then(response => {
							response.data[0].docs = JSON.parse(response.data[0].docs)

							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data[0])
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		setInvoiceStatus(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/SetInvoiceStatus?id=${parameters.id}&status=${parameters.status}&comment=${parameters.comment}`)
						.then(response => {
							var approving = parameters.status == 4

							actionContext.commit("Toasts/showSuccess", { title: approving ? "Approved" : "Rejected", content: `Invoice ${approving ? "approved" : "rejected"}!` }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getInvoiceStatuses(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"d_ddlo.value, " +
						"d_ddlo.name";

					var tableName = "" +
						"@db.def_ddloptions d_ddlo " +
						"inner join @db.def_fields d_f on d_ddlo.fieldid = d_f.id " +
						"inner join @db.def_tables d_t on d_f.tableid = d_t.id";

					var filter = "" +
						"d_t.name = 'pminvoice' " +
						"and d_f.name = 'status'";

					actionContext.rootGetters["MopaneApi/getInstance"].get("Service/GetTableData?columns=" + columns + "&tableName=" + tableName + "&filter=" + filter)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setInvoiceStatuses", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setInvoices(state, invoices) {
			state.invoices = invoices
				.map(invoice => {
					var statusName = state.invoiceStatuses.filter(x => x.value == invoice.status)[0].name

					invoice.statusname = statusName

					return invoice
				})
		},
		setInvoiceStatuses(state, invoiceStatuses) {
			state.invoiceStatuses = invoiceStatuses
		}
	},

	namespaced: true
}